<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
  <button class="btn btn-primary btn-md" [mat-dialog-close]="true" tabindex="2">Ok</button>
  <button class="btn btn-tertiary btn-md" (click)="onNoClick()" tabindex="-1">Cancel</button>
</div>
